import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { fetchUsuario } from '../../actions/usuariosActions';
import { postUser } from '../../api/axios';
import PasswordValidation from "./PasswordValidation";
import GoBackArrow from '../General/GoBackArrow';
import MiniSpinner from '../General/MiniSpinner';
import { DropDownArrow, customStyle } from "../../template/CustomStyle";
import { isEmail } from '../../utilities/formatString';
import { toast } from 'react-toastify';


class UserNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idSeller: this.props.idSeller,
            password: "",
            confirmarPassword: "",
            passValidation: false,
            usuario: "",
            email: "",
            usuarioError: true,
            showSpinner: false,
            tipoUsuario: { value: null, label: null },
            idProveedor: ""
        };
        this.tiposUsuario = [
            { value: 1, label: "Category" },
            { value: 6, label: "Solo Lectura" },
            { value: 7, label: "Proveedor" }
        ]
    };

    componentDidMount() {
        if (this.props.userType.isAdminMod) {
            this.setState({ tipoUsuario: this.tiposUsuario[this.props.location.state?.dropdownSelect ?? 0] });
        } else {
            this.setState({ tipoUsuario: { value: 4, label: "Seller" } });
        }
    }

    componentWillReceiveProps() {
        this.setState({ email: this.props.usuario.email, usuario: this.props.usuario.nombreUsuario })
    }


    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmarPassword = (e) => {
        const { value } = e.target;
        this.setState({
            usuarioError: value !== this.state.password,
            confirmarPassword: value
        });
    }

    myChangeHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    selectTipoUsuarioHandler = (options, config) => {
        this.setState({ [config.name]: options });
    }

    handleChangeImporte = (e) => {
        const { value } = e.target;
        this.setState({ idProveedor: parseInt(value) });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        if (!isEmail(this.state.email)) {
            toast.warn("Mail incorrecto");
            return;
        }

        if (this.state.usuario == "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        if (this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        if (!this.state.passValidation) {
            toast.warn("La contraseña no cumple con los requisitos");
            return;
        }

        if (this.state.tipoUsuario.value === 7) {
            if (this.state.idProveedor === "") {
                toast.warn("Ingrese un id de proveedor");
                return;
            }
        }

        this.setState({ showSpinner: true });

        let usuario = {
            idSeller: this.props.idSeller,
            password: this.state.password,
            usuario: this.state.usuario,
            email: this.state.email,
            enviarEmail: true,
            tipoUsuario: this.state.tipoUsuario.value,
            idUsuario: this.props.idUsuario,
            idProveedor: this.state.tipoUsuario.value === 7 ? this.state.idProveedor : null,
        }

        let usuarios = postUser(usuario);

        usuarios.then(res => {
            toast.success("Usuario agregado exitosamente");
            this.goBack();
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.warn(error))
                : toast.error("No pudo crearse");
        }).finally(() => {
            this.setState({ showSpinner: false });
        });
    }

    goBack = () => {
        window.history.go(-1);
    }


    render() {
        return (
            <form className="card form-horizontal form-material" onSubmit={this.onSubmit}>
                <div
                    id="home2"
                    name="datos"
                    role="tabpanel"
                    className="row tab-content tab-pane active p-3"
                >
                    <div className="col-12 mb-3">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Crear usuario</h4>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label>Email Usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.email}
                                onChange={this.myChangeHandler}
                                placeholder="usuario@dominio.com"
                                name="email"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label>Usuario</label>
                            <input
                                type="text"
                                className="form-control"
                                value={this.state.usuario}
                                onChange={this.myChangeHandler}
                                placeholder="nombreUsuario"
                                name="usuario"
                                maxLength="40"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={this.state.nuevoPassword}
                                onChange={this.myChangeHandler}
                                maxLength="12"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="form-group">
                            <label>Confirmar contraseña</label>
                            <input
                                type="password"
                                className={`form-control ${this.state.usuarioError ? "warning-input" : ""}`}
                                value={this.state.confirmarPassword}
                                onChange={this.confirmarPassword}
                                maxLength="12"
                            />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 d-inline">
                        <label htmlFor="passwordValidation">Requisitos contraseña</label>
                        <PasswordValidation
                            password={this.state.password}
                            isValidPassword={this.handlePassValidation}
                        />
                    </div>

                    {this.props.userType.isAdminMod &&
                        <div className="col-12 col-sm-3">
                            <label className="label-oscura">Tipo Usuario</label>
                            <Select
                                name="tipoUsuario"
                                value={this.state.tipoUsuario}
                                options={this.tiposUsuario}
                                onChange={this.selectTipoUsuarioHandler}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                            />
                        </div>
                    }

                    {this.state.tipoUsuario.value === 7 &&
                        <div className="col-12 col-sm-3">
                            <label className="label-oscura" htmlFor="idProveedor">Id Poveedor</label>
                            <input
                                type="number"
                                name="idProveedor"
                                id="idProveedor"
                                aria-label="idProveedor"
                                className="form-control"
                                onChange={this.handleChangeImporte}
                                min="0"
                            />
                        </div>
                    }

                    <div className="col-12 mt-4">
                        <div className="row justify-content-center align-items-center">

                            <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                <MiniSpinner />
                            </div>

                            <div className="col-12 col-sm-auto">
                                <button
                                    type="submit"
                                    disabled={this.state.showSpinner}
                                    className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                >
                                    Guardar
                                </button>
                            </div>

                            <div className="col-12 col-sm-auto">
                                <button
                                    type="button"
                                    onClick={this.goBack}
                                    className="btn btn-sm btn-light waves-effect waves-light col-auto"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        );
    }
}


const mapStateToProps = (state) => ({
    idUsuario: state.general.userId,
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    settedSellerObject: state.general.generalObject,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,
    usuario: JSON.stringify(state.usuarios.user) != "{}" ? state.usuarios.user : "{}"
});

export default connect(mapStateToProps, { fetchUsuario })(UserNew);